import { SegmentedControl } from "../../design-v2";

export default function SegmentedSelector({ options, value, onChange, label, disabled = false }) {
  return (
    <SegmentedControl
      options={options}
      value={value}
      onChange={onChange}
      label={label}
      disabled={disabled}
    />
  );
}
